
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M2.11998 2.31997C1.72998 1.92997 1.09998 1.92997 0.70998 2.31997C0.31998 2.70997 0.31998 3.33997 0.70998 3.72997L4.97998 7.99997C3.32998 8.00997 1.99998 9.34997 1.99998 11V15C1.99998 16.1 2.89998 17 3.99998 17H5.99998V19C5.99998 20.1 6.89998 21 7.99998 21H16C16.55 21 17.04 20.78 17.4 20.42L20.23 23.25C20.62 23.64 21.25 23.64 21.64 23.25C22.03 22.86 22.03 22.23 21.64 21.84L2.11998 2.31997ZM15 19H8.99998C8.44998 19 7.99998 18.55 7.99998 18V14H10.98L15.7 18.72C15.51 18.89 15.27 19 15 19ZM19 7.99997H10.63L19.63 17H20C21.1 17 22 16.1 22 15V11C22 9.33997 20.66 7.99997 19 7.99997ZM19 12C18.45 12 18 11.55 18 11C18 10.45 18.45 9.99997 19 9.99997C19.55 9.99997 20 10.45 20 11C20 11.55 19.55 12 19 12ZM17 6.99997C17.55 6.99997 18 6.54997 18 5.99997V3.99997C18 3.44997 17.55 2.99997 17 2.99997H6.99998C6.62998 2.99997 6.31998 3.20997 6.14998 3.50997L9.62998 6.99997H17Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-print-disabled`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconPrintDisabled

    ```js
    <b-new-b-icon-print-disabled />
    ```
</docs>


